import { FC, RefObject, useCallback, useEffect, useRef, useState } from "react";
import { NumberInputProps } from "./types";
import { useThemeStore } from "../../../stores";
import { Column } from "../../containers";
import { AlignItems, JustifyContent } from "../../containers/types";
import { Heading } from "../../typography";
import { UpdateFn } from "../../../types";
import { addComma, removeComma } from "../../../utils";

const NumberInput: FC<NumberInputProps> = ({
  label,
  setValue,
  value,
  props,
  background,
  color,
  className = "",
  style = {},
  inputProps,
  price = false,
}) => {
  const theme = useThemeStore((state) => state.theme);
  const ref: RefObject<HTMLInputElement> = useRef<HTMLInputElement>(null);

  const ac = price ? addComma : (a: any): any => a;
  const rc = price ? removeComma : (a: any): any => a;

  const handler = useCallback(
    (e: MouseEvent): void => {
      if ((e.target as Element).tagName.toLowerCase() !== "input") {
        ref.current?.blur();
      }
    },
    [ref]
  );

  useEffect(() => {
    window.addEventListener("click", handler);
    return (): void => {
      window.removeEventListener("click", handler);
    };
  }, [handler]);

  const [strValue, setStrValue] = useState<string>("");

  useEffect(() => {
    setStrValue(ac(String(value)));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value]);

  const onInpChange = (
    e: React.ChangeEvent<HTMLInputElement>,
    set: UpdateFn<string>
  ) => {
    if (e.target.value.includes(".")) return;
    let val = Number(rc(e.target.value));
    if (isNaN(val)) return;
    set(ac(rc(e.target.value.trim())));
    setValue(Number(rc(e.target.value.trim())));
  };

  return (
    <Column
      alignItems={AlignItems.Start}
      justifyContent={JustifyContent.Start}
      gap={5}
      className={className}
      style={{ width: "100%", ...style }}
      props={props}
    >
      <Heading color={color || theme.textOnOverlay} size={16}>
        {label}
      </Heading>
      <input
        ref={ref}
        value={strValue}
        onChange={(e) => onInpChange(e, setStrValue)}
        style={{
          borderRadius: 15,
          background: background || theme.background,
          width: "calc(100% - 10px)",
          height: 41,
          paddingRight: 10,
          color:
            background === theme.background
              ? theme.textOnBg
              : theme.textOnOverlay,
        }}
        {...inputProps}
      />
    </Column>
  );
};

export default NumberInput;
